import { FormControl, FormHelperText, FormLabel, TextField, styled } from '@mui/material';
import { Controller } from 'react-hook-form';
import LocationSearchAutoComplete from '../../LocationSearchAutoComplete';

const ReactLocationInput = (props) => {
    const {
        hookFormControl,
        label,
        formLabel,
        varName,
        multiSelect = false,
        disabled = false,
        errorMessage = null,
        autoFocus = false,
        helperText = null,
        size = "small",
        inputProps = null,
        variant = "outlined",
        width = '100%',
        placeholder = "",
        options
    } = props;

    return (
        <>
            <FormControl error={errorMessage !== null} sx={{ maxWidth: '500px', width: '100%' }} size={size} variant={variant}>
                {formLabel && (
                    <FormLabel className="text-[16px] font-['Matter-Medium'] text-black mb-2">{formLabel}</FormLabel>
                )}
                <Controller
                    name={varName}
                    control={hookFormControl}
                    render={({ field }) => (
                        <LocationSearchAutoComplete
                            id={varName}
                            disabled={disabled}
                            autoFocus={autoFocus}
                            placeholder={placeholder}
                            multiSelect={multiSelect}
                            size={size}
                            data={options}
                            {...field}
                            label={label}
                            value={field.value ?? ""}
                            inputProps={{ className: "MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputSizeSmall MuiInputBase-inputAdornedStart MuiInputBase-inputAdornedEnd MuiAutocomplete-input MuiAutocomplete-inputFocused font-['Poppins-Regular'] text-[15px] border-[#3A3A3A]" }}
                        />
                       
                    )}
                />
                {!errorMessage && helperText && (
                    <FormHelperText className="ml-0 font-['Poppins-Regular']" id="component-info-text">
                        {helperText}
                    </FormHelperText>
                )}
                {errorMessage && (
                    <FormHelperText className="ml-0 font-['Poppins-Regular']" id="component-error-text">
                        {errorMessage}
                    </FormHelperText>
                )}
            </FormControl>
        </>
    );
};

export default ReactLocationInput;